<template>

  <nav class="navbar navbar-default">
        <div class="container-fluid">
            <div class="navbar-header">
                <a class="navbar-brand" :href="appRoot"><logo /></a>
            </div>

            <ul class="nav navbar-nav navbar-right">
              <li><a href="static/devDocs.pdf" target=_blank><icon name="book" /> API</a></li>
              <li><router-link to="/docs"><icon name="book" /> Help</router-link></li>
            </ul>
        </div>
  </nav>

</template>

<script>
import logo from 'components/utils/Logo'
import constants from 'constants.js'

export default {
  name: 'mainBar',
  data () {
    return {
      appRoot: constants.APP_ROOT
    }
  },
  components:{
    logo
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// MainBar.vue?5a0fdc7a